import { Column } from "@bridgesplit/ui";

import WithdrawAmounts from "./WithdrawAmounts";
import WithdrawCtaStats from "./WithdrawCtaStats";
import WithdrawCta from "./WithdrawCta";
import { ManagePositionWrapper } from "../../clmm";
import { useRaydiumContext } from "../RaydiumContext";

function WithdrawTop() {
    return <WithdrawAmounts />;
}

function WithdrawBottom() {
    const context = useRaydiumContext();

    return (
        <Column spacing={2}>
            <WithdrawCtaStats />
            <ManagePositionWrapper context={context} actionType="withdraw">
                <WithdrawCta />
            </ManagePositionWrapper>
        </Column>
    );
}

export const Withdraw = {
    Top: WithdrawTop,
    Bottom: WithdrawBottom
};
